module.exports = __webpack_public_path__ + "static/media/discord-icon.3088d1c9.svg";